<template>
  <Modal open title="Notes" no-footer @hide-modal="emit('close')">
    <div class="employee-details mb-4">
      <div class="d-flex gap-3 mb-1">
        <div class="text-title">Employee:</div>
        <a v-if="employee?.links?.show" :href="employee?.links?.show">{{
          employeeName
        }}</a>
        <div v-else>{{ employeeName }}</div>
      </div>
      <div class="d-flex gap-3">
        <div class="d-flex gap-3 flex-1">
          <div class="text-title">Start Time:</div>
          <div class="text-body">
            {{
              customDateFormatWithTimezone(
                timeCard.start_time,
                "MM/DD/YYYY - h:mm:ss a"
              )
            }}
          </div>
        </div>
        <div class="d-flex gap-3 flex-1">
          <div class="text-title">End Time:</div>
          <div class="text-body">
            {{
              timeCard?.end_time
                ? customDateFormatWithTimezone(
                    timeCard.end_time,
                    "MM/DD/YYYY - h:mm:ss a"
                  )
                : "Not Available"
            }}
          </div>
        </div>
      </div>
    </div>
    <Notes
      :commentable-id="timeCard.id"
      commentable-type="TimeCard"
      hide-form
      title=""
      :all="true"
      :allow-edit="false"
    />
  </Modal>
</template>

<script setup lang="ts">
import { computed, onBeforeMount } from "vue";
import { useStore } from "vuex";

import Modal from "@/components/Modal.vue";
import Notes from "@/Comments/Comments.vue";
import { TimeCard } from "@/typings/timeCard";

const store = useStore();
const emit = defineEmits(["close"]);
const props = defineProps<{ timeCard: TimeCard }>();

interface Employee {
  archived: boolean;
  full_name: string;
  gid: string;
  id: number;
  links: { show?: string };
  role: string;
}

const employee = computed<Employee | undefined>(() =>
  store.state.timeCardEmployees.find(
    (employee: Employee) => employee.id === props.timeCard.employee_id
  )
);

const employeeName = computed(() => {
  if (!employee.value) {
    return "--";
  }
  return employee.value?.full_name;
});

onBeforeMount(() => {
  if (!store.state.timeCardEmployees.length) {
    store.dispatch("fetchTimeCardEmployees");
  }
});
</script>

<style scoped>
.employee-details {
  background: var(--sera-color-neutral-gray-light-gray-50);
  padding: 16px;
}
</style>
